import getFetchOptions from '../utils/getFetchOptions';

import {ENDPOINT_URL} from '../constants';

export default function getUserGrade() {
	return fetch(
		`${ENDPOINT_URL}/usergrade`,
		getFetchOptions({
			method: 'GET',
		})
	).then((response) => {
		if (!response.ok) {
			throw response;
		}
		return response.json();
	});
}
